<template>
  <router-link :to="outcome">
    <slot />
  </router-link>
</template>

<script>
import { format, parseISO } from "date-fns";
export default {
  name: "CalendarLink",
  props: ["date"],
  computed: {
    outcome() {
      return this.date != null
        ? {
            to: this.$route.name,
            query: {
              date: format(parseISO(this.date), "yyyyMMdd"),
            },
          }
        : {
            to: this.$route.name,
          };
    },
  },
};
</script>
